export default __webpack_public_path__ + "static/new-hero-desktop-453fac84d8df8ffc3b5b5a716dabb083.png";